module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center",
    staticStyle: {
      "height": "450px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.pageLoader_img
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loading... Please Wait")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-097d9790", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-097d9790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PageLoader.vue
// module id = 476
// module chunks = 4